import React from 'react';
import { View } from 'react-native';

const Divider: React.FC = () => {
  return <View className="h-[1px] bg-gray-100 w-full my-5" />;
};

export default Divider;
